module.exports = __webpack_public_path__ + "static/media/kite.4ad2ec50.svg";